import { config } from '.';

// Extract the most popular labels for each of the properties, based on the edit configuration

export const labelForConfigPropertyMap = (() => {
  const dict = new Map<string, string>();
  const labelCount = new Map<string, Map<string, number>>();

  Object.values(config).forEach((nodeConfig) => {
    if ('edit' in nodeConfig) {
      nodeConfig.edit.forEach((edit) => {
        if (edit.property && edit.label) {
          if (!labelCount.has(edit.property)) {
            labelCount.set(edit.property, new Map<string, number>());
          }
          const propertyLabels = labelCount.get(edit.property) as Map<string, number>;
          propertyLabels.set(edit.label, (propertyLabels.get(edit.label) || 0) + 1);
        }
      });
    }
  });

  labelCount.forEach((labels, property) => {
    let mostFrequentLabel = '';
    let secondMostFrequentLabel = '';
    let maxCount = 0;
    let secondMaxCount = 0;

    labels.forEach((count, label) => {
      if (count > maxCount) {
        secondMaxCount = maxCount;
        secondMostFrequentLabel = mostFrequentLabel;
        maxCount = count;
        mostFrequentLabel = label;
      } else if (count > secondMaxCount) {
        secondMaxCount = count;
        secondMostFrequentLabel = label;
      }
    });

    // if the top two labels are close in frequency, show both
    if (secondMaxCount > 0 && maxCount / secondMaxCount < 2) {
      dict.set(property, `${mostFrequentLabel} / ${secondMostFrequentLabel}`);
    } else {
      dict.set(property, mostFrequentLabel);
    }
  });

  return dict;
})();
